<template>
    <card-group>
        <template v-slot:meta>
            <v-col cols="12">
                <v-text-field v-model="mValue.Title" label="Title"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
				<NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
            </v-col>
        </template>

        <template v-slot:Cards>
			<DraggableGroupItems
				v-model="mValue.Cards"
				items-label="Card"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<image-selector :aspect-ratio="16/9" v-model="item.image" label="Card Image" :show-image="true"></image-selector>
					<v-text-field class="mt-5" label="Title" v-model="item.title"></v-text-field>
					<text-editor label="Text" v-model="item.text"></text-editor>
					<v-text-field class="mt-7" label="Button Text" v-model="item.buttonText"></v-text-field>
					<url-selector v-model="item.buttonHref" label="Button Link"></url-selector>
					<v-checkbox class="mt-0" v-model="item.newWindow" label="open in new window" false-value="_self" true-value="_blank"></v-checkbox>
					<v-text-field class="mt-5" label="Copy to Clipboard Text" v-model="item.copyText"></v-text-field>
					<v-text-field label="Content to Copy" v-model="item.copyToClipboard"></v-text-field>
					<v-select :items="button_alignments" v-model="item.buttonAlignment"></v-select>
				</template>
			</DraggableGroupItems>
        </template>
    </card-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import ImageSelector from '../ImageSelector.vue'
import UrlSelector from '../UrlSelector.vue'
import CardGroup from '@/CMS/views/ContentBlocks/CardGroup.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
	components: {
        TextEditor,
        CardGroup,
        UrlSelector,
        ImageSelector,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
    props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'Cards', // override Mixin
            button_alignments: [{
                    text: "Left",
                    value: "left"
                },
                {
                    text: "Center",
                    value: "center"
                },
                {
                    text: "Right",
                    value: "right"
                }
            ],
        }
    },
    methods: {
        reset () { // override Mixin
			const value = { ...this.mValue }
			if (typeof value.Cards === 'undefined') {
				value.Cards = [this.getNewItem()]
			}
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 4
			}
			value.Cards.map((card) => {
				const item = { ...card }
				if (typeof item.id === 'undefined') {
					this.counter = this.counter + 1
					item.id = this.counter
				}
				return item
			})
			this.mValue = value
        },
        getNewItem () { // override Mixin
            this.counter = this.counter + 1
			return {
				id: this.counter,
				image: 'https://hq-image-cdn.azureedge.net/servers/public/cms_images/16x9-placeholder_wvC2Ck.jpg',
				title: '',
				text: '',
				buttonText: '',
				buttonHref: '',
				newWindow: true,
				copyText: '',
				copyToClipboard: '',
				buttonAlignment: 'left',
			}
        },
    },
}
</script>
